import { TypographyOptions } from '@mui/material/styles/createTypography';
import { tokens } from '../../theme/generated/tokens';
import { TypographyVariant } from '../../theme/generated/typography';
import { typographyTheme as generatedTypographyTheme } from '../../theme/generated/typographyTheme';

const fontWeightBold = 600;
const fontWeightMedium = 500;
const fontWeightRegular = 400;

export const typographyVariantMapping: Record<TypographyVariant, string> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',

  A1: 'strong',
  A2: 'strong',
  A3: 'strong',

  P40B: 'p',
  P20B: 'p',
  P18B: 'p',
  P16B: 'p',
  P14B: 'p',
  P12B: 'p',
  P10B: 'p',
  P8B: 'p',

  P20M: 'p',
  P18M: 'p',
  P16M: 'p',
  P14M: 'p',
  P12M: 'p',
  P10M: 'p',
  P8M: 'p',

  P20R: 'p',
  P18R: 'p',
  P16R: 'p',
  P14R: 'p',
  P12R: 'p',
  P10R: 'p',

  L14B: 'p',
  L12B: 'p',
  L10B: 'p',

  L14M: 'p',
  L12M: 'p',
  L10M: 'p',
  L8M: 'p',

  L14R: 'p',
  L12R: 'p',
  L10R: 'p',

  metriclg: 'span',
  metricmd: 'span',
  metricsm: 'span',
  metricxs: 'span',

  C16: 'pre',
  C14: 'pre',
  C12: 'pre',
};

export const typographyTheme: TypographyOptions = {
  ...generatedTypographyTheme,
  fontSize: 12,
  fontFamily: tokens.primitives.fontFamily.body,
  fontWeightBold,
  fontWeightMedium,
  fontWeightRegular,
};
